// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: var(--ink-900);
  padding: 64px 0 0;
}

.footer__inner {
  display: grid;
  grid-template-columns: 1.4fr 0.85fr 0.85fr 0.85fr 0.85fr 0.85fr;
  gap: 32px;
  padding-bottom: 48px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 19px;
  color: #fff;
}

.footer__logo img {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  object-fit: cover;
}

.footer__logo-accent {
  color: var(--teal);
}

.footer__brand > p:not(.footer__mute) {
  margin-top: 16px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 14.5px;
  color: var(--amber);
}

.footer__mute {
  display: block;
  margin-top: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
  max-width: 300px;
  line-height: 1.6;
}

.footer__col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer__col h4 {
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.footer__col a {
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.55);
  transition: color 0.15s ease;
}

.footer__col a:hover {
  color: var(--teal);
}

.footer__link-btn {
  text-align: left;
  background: transparent;
  font-family: var(--font-body);
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.55);
  transition: color 0.15s ease;
  cursor: pointer;
}

.footer__link-btn:hover {
  color: var(--teal);
}

.footer__bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.4);
}

@media (max-width: 980px) {
  .footer__inner {
    grid-template-columns: 1fr 1fr;
  }
  .footer__brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 560px) {
  .footer__inner {
    grid-template-columns: 1fr;
  }
  .footer__bottom {
    flex-direction: column;
    gap: 6px;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;AACF","sourcesContent":[".footer {\n  background: var(--ink-900);\n  padding: 64px 0 0;\n}\n\n.footer__inner {\n  display: grid;\n  grid-template-columns: 1.4fr 0.85fr 0.85fr 0.85fr 0.85fr 0.85fr;\n  gap: 32px;\n  padding-bottom: 48px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.footer__logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 19px;\n  color: #fff;\n}\n\n.footer__logo img {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  object-fit: cover;\n}\n\n.footer__logo-accent {\n  color: var(--teal);\n}\n\n.footer__brand > p:not(.footer__mute) {\n  margin-top: 16px;\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 14.5px;\n  color: var(--amber);\n}\n\n.footer__mute {\n  display: block;\n  margin-top: 10px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.45);\n  max-width: 300px;\n  line-height: 1.6;\n}\n\n.footer__col {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer__col h4 {\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n\n.footer__col a {\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.55);\n  transition: color 0.15s ease;\n}\n\n.footer__col a:hover {\n  color: var(--teal);\n}\n\n.footer__link-btn {\n  text-align: left;\n  background: transparent;\n  font-family: var(--font-body);\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.55);\n  transition: color 0.15s ease;\n  cursor: pointer;\n}\n\n.footer__link-btn:hover {\n  color: var(--teal);\n}\n\n.footer__bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 22px 24px;\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n@media (max-width: 980px) {\n  .footer__inner {\n    grid-template-columns: 1fr 1fr;\n  }\n  .footer__brand {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 560px) {\n  .footer__inner {\n    grid-template-columns: 1fr;\n  }\n  .footer__bottom {\n    flex-direction: column;\n    gap: 6px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
